export default "/images/vendor/flag-icons/flags/4x3/hk.svg?206f3ee8617b71afa3964d071e0fc36e";